import { useNavigate } from '@tanstack/react-router'
import { ArrowRight } from 'lucide-react'
import { useBuildTeamCta } from '@/features/agents-marketing/hooks/useBuildTeamCta'
import { Reveal } from '@/shared/components/Reveal'
import { Button } from '@/components/ui/button'

export function AgentsCta() {
  const navigate = useNavigate()
  const build = useBuildTeamCta()

  return (
    <section className="w-full px-6 pb-28">
      <Reveal className="mx-auto max-w-6xl">
        <div className="beam-border grain relative overflow-hidden rounded-[2rem] bg-[var(--color-bg-secondary)] px-8 py-20 text-center md:px-16 md:py-28">
          <div
            aria-hidden
            className="pointer-events-none absolute -bottom-1/2 left-1/2 h-full w-3/4 -translate-x-1/2 rounded-full bg-[radial-gradient(closest-side,color-mix(in_srgb,var(--color-primary)_22%,transparent),transparent)]"
          />
          <div className="relative z-10 mx-auto max-w-3xl">
            <h2 className="text-[clamp(2.75rem,7vw,5.5rem)] font-semibold leading-[0.95] tracking-[-0.05em] text-balance">
              <span className="text-sheen">Ready to build your </span>
              <span className="text-brand">first team?</span>
            </h2>
            <p className="mt-6 text-lg text-[var(--color-text-secondary)]">
              One coordinator, the specialists you pick, and one model id in
              your code.
            </p>
            <div className="mt-10 flex flex-col justify-center gap-3 sm:flex-row">
              <Button onClick={() => navigate({ to: build.to })} size="lg" className="px-8 font-semibold">
                {build.label}
                <ArrowRight />
              </Button>
              <Button
                onClick={() => navigate({ to: '/models' })}
                variant="outline"
                size="lg"
                className="px-8 font-semibold"
              >
                Browse the catalog
              </Button>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  )
}
